module.exports = __webpack_public_path__ + "img/BellNotification2.7e7859fd.svg";